import {Component, DestroyRef, inject, Inject, OnInit, ViewEncapsulation} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {MAT_SNACK_BAR_DATA} from '@angular/material/snack-bar';
import {Router} from '@angular/router';
import {MainDataModels} from 'src/app/models/maindata-models';
import {DatumFormatPipe} from 'src/app/pipes/datum-format.pipe';
import {MainDataService} from 'src/app/services/main-data.service';
import {MessageBoxService} from 'src/app/services/message-box.service';
import {SwissSettingsService} from 'src/app/services/swiss-settings.service';
import {NotizEintragComponent} from '../../pendenzen/notiz-eintrag/notiz-eintrag.component';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';

export interface NotizEintrag {
  id: string;
  datum: Date;
  title: string;
  notiz: string;
}

@Component({
  selector: 'app-notiz-liste',
  templateUrl: './notiz-liste.component.html',
  styleUrls: ['./notiz-liste.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class NotizListeComponent implements OnInit {
  private dbNotizen?: MainDataModels.Notiz[];
  public noteList: NotizEintrag[] = [];
  private currNotizMitBenutzern?: MainDataModels.NotizMitBenutzer;

  private destroyRef = inject(DestroyRef);

  constructor(
    private svcMainData: MainDataService,
    private _datumFormatPipe: DatumFormatPipe,
    private svcMessageBox: MessageBoxService,
    public dialog: MatDialog,
    private swissSettings: SwissSettingsService,
    private router: Router,
    @Inject(MAT_SNACK_BAR_DATA) public data: any
  ) {}

  ngOnInit(): void {
    this.loadNotizen();
  }

  loadNotizen() {
    // Unerledigte Notizen Live vom Webservice holen
    this.svcMainData.getUserNotes().pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: (res) => {
        this.dbNotizen = res;
        this.loadListenNotizen();
      },
      error: () => {
        // Webservice nicht verfügbar --> aus IndexedDB laden
        //this.loadTermineFromIndexedDB();
      },
    });
  }

  loadListenNotizen() {
    if (this.dbNotizen) {
      this.noteList = [];

      this.dbNotizen.forEach((n) => {
        this.noteList.push({
          id: n.noteID,
          datum: n.modified,
          title: n.description,
          notiz: n.notes,
        });
      });
    }
  }

  formatDate(datum: Date): string {
    // Formatiert das Datum in das Format "dd.MM.yyyy HH:mm"
    return this._datumFormatPipe.transformDateWithTime(datum);
  }

  closeSnackbar() {
    this.data.preClose();
  }

  showNotizList() {
    this.data.preClose();
    this.router.navigate(['/meinenotizen']);
  }

  showNotizDetail(notiz: NotizEintrag) {
    this.svcMainData.loadNoteByID(notiz.id).subscribe({
      next: (res) => {
        var dialogRef = this.dialog.open(NotizEintragComponent, {
          disableClose: true,
          width: '800px',
          data: res,
        });

        dialogRef.afterClosed().subscribe({
          next: (result) => {
            this.currNotizMitBenutzern = result;
            if (this.currNotizMitBenutzern) {
              // Update Informations
              this.svcMainData.saveNotiz(this.currNotizMitBenutzern).subscribe({
                next: () => {
                  this.svcMessageBox.showSuccess(
                    'Die Notiz wurde erfolgreich gespeichert.',
                    'Erfolgreich'
                  );
                  this.svcMainData.refreshNoteCount();
                },
                error: (error) => {
                  console.log(error);
                  this.svcMessageBox.showError(
                    'Die Notiz konnte nicht gespeichert werden!!',
                    '!! FEHLER !!'
                  );
                },
              });
              if (this.swissSettings.getWebConfig().debugMode)
                console.log(
                  'Dialog Resultat (currNotizMitBenutzern): ',
                  this.currNotizMitBenutzern
                );
            }
          },
        });
      },
    });
  }
}
